export default "__VITE_ASSET__DhhdHoyT__"